import { alwaysRefetchApiQueryOptions } from 'BreetHelpers';
import { useFormStage } from 'BreetHooks';
import { useGetUserWalletsQuery } from 'BreetRedux';

import Child from './Child';
import { RateCalculatorProvider } from './components/FormProvider';
import { RateCalculatorFormStageContext } from './components/FormStageContext';
import { rateCalculatorStageTitle, type RATECALCULATORTYPE } from './DialogRateCalculator.helpers';

const DialogRateCalculator = () => {
	useGetUserWalletsQuery(undefined, alwaysRefetchApiQueryOptions);

	const formStage = useFormStage<RATECALCULATORTYPE>(
		'rate-calculator',
		['rate-calculator', 'asset-details'],
		rateCalculatorStageTitle
	);

	return (
		<RateCalculatorFormStageContext.Provider value={formStage}>
			<RateCalculatorProvider>
				<Child />
			</RateCalculatorProvider>
		</RateCalculatorFormStageContext.Provider>
	);
};

export default DialogRateCalculator;
